var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "modal",
    attrs: {
      variant: "default",
      "cta-text": _vm.tc("spaSoft.step1.contactPopupCta"),
      "aria-labelled-by": "spa-contact-popup-title",
    },
    on: { input: _vm.handleOpenModal },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "body",
          fn: function () {
            return [
              _c("div", [
                _c(
                  "h6",
                  {
                    staticClass: "title",
                    attrs: { id: "spa-contact-popup-title" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tc("spaSoft.step1.contactPopupTitle")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "content-body" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.notificationText) },
                  }),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }